import { AxiosResponse } from 'axios';

import { serverAxios } from '../../http';
import { IGoogleGetGeoBatchResponse, IGoogleGetGeolocationResponse } from 'models/http/google';
import { HttpTimeoutPriority } from 'utils/enums/http-timeout-priority';

class googleHttp {
  private static route = '/googleapis';

  public async getGeoLocation(address: string, abortController?: AbortController): Promise<IGoogleGetGeolocationResponse> {
    return serverAxios
      .post(`${googleHttp.route}/geolocation/`, { address }, { signal: abortController?.signal, timeout: HttpTimeoutPriority.Medium })
      .then((response: AxiosResponse<IGoogleGetGeolocationResponse>) => {
        return response.data;
      });
  }

  public async getGeoLocationBatch(
    addresses: string[],
    abortController?: AbortController,
  ): Promise<IGoogleGetGeoBatchResponse['coordinates']> {
    return serverAxios
      .post(`${googleHttp.route}/geo-batch/`, { addresses }, { signal: abortController?.signal, timeout: HttpTimeoutPriority.Highest })
      .then((response: AxiosResponse<IGoogleGetGeoBatchResponse>) => {
        return response.data.coordinates;
      });
  }

  public async getAddressNameByCoordinates(coordinates: { lat: number; lng: number }): Promise<string> {
    return serverAxios
      .get(`${googleHttp.route}/lookup/coordinates/${coordinates.lat},${coordinates.lng}`)
      .then((response: AxiosResponse<string>) => {
        return response.data;
      });
  }
}

export default googleHttp;
